import { CampaignType, EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { Ok, Result } from 'ts-res';
import { KameleoonError } from 'src/kameleoonError';
import { FeatureFlagVariationType } from 'src/storage/types';
import { PersonalizationDataType } from 'src/kameleoonData/types';

export class ExclusiveExperimentCondition implements ICondition {
  private campaignType?: CampaignType | null;

  constructor({ campaignType }: ConditionDataType) {
    this.campaignType = campaignType;
  }

  public evaluate(data: EvaluationDataType): Result<boolean, KameleoonError> {
    return Ok(this.checkCondition(data));
  }

  private checkCondition(data: EvaluationDataType): boolean {
    const variations = Object.values(data.variationData);
    const personalizations = Object.values(data.targetingData?.personalization || {});

    const hasSingleValidVariation =
      variations.length === 1 &&
      data.experimentId !== null &&
      data.variationData[data.experimentId] !== undefined;

    const hasNoVariations = variations.length === 0;
    const hasNoPersonalizations = personalizations.length === 0;

    switch (this.campaignType) {
      case CampaignType.Experiment:
        return hasNoVariations || hasSingleValidVariation;
      case CampaignType.Personalization:
        return hasNoPersonalizations;
      case CampaignType.Any:
        return hasNoPersonalizations && (hasNoVariations || hasSingleValidVariation);
      default:
        return false;
    }
  }
}
